import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, switchMap, timer } from 'rxjs';
import { PageTitleService } from '@uc/cms/core';
import { VisitsApiService } from '../../../../libs/cms/features/content/src/lib/data-access/visits/visits-api.service';

@Injectable({ providedIn: 'root' })
export class RouteTrackingService {
	private _router = inject(Router);
	private _document = inject(DOCUMENT);
	private _pageTitleSrv = inject(PageTitleService);
	private _visitsApiSrv = inject(VisitsApiService);

	trackRouteChange() {
		this._router.events
			.pipe(
				filter((e): e is NavigationEnd => e instanceof NavigationEnd),
				switchMap(() =>
					timer(0).pipe(
						switchMap(() =>
							this._pageTitleSrv.title$.pipe(
								map((title) => ({ title, url: this._router.url })),
							),
						),
					),
				),
			)
			.subscribe(({ title, url }) => {
				const pageTitle = title || this._document.title || '';
				this._recordVisit(pageTitle, url);
			});
	}

	private async _recordVisit(title: string, url: string) {
		if (!title || !url) return;

		const payload = {
			title,
			url,
			visited_at: new Date().toISOString(),
		};

		try {
			await this._visitsApiSrv.addVisit(payload);
		} catch (error: any) {
			console.error('Error recording visit:', error);
		}
	}
}
